module.exports = "/_next/static/images/706b75965245b3f4e8bbf3e69d4b5c62-phone-icon.svg.webp";